// extracted by mini-css-extract-plugin
module.exports = {"cont":"donationHome-module--cont--1-J0Z","textCont":"donationHome-module--textCont--2gD7R"};